import React, { Component } from 'react';

class Mlitem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
  };

  render() {
      let reject = '';
      if(this.props.record.reject_author_ids) {
          reject = '거절AID: ' + this.props.record.reject_author_ids;
      }
      let nomail = '';
      if(this.props.record.nomail_author_ids) {
          nomail = 'No메일: ' + this.props.record.nomail_author_ids;
      }
    return (
      <tr>
        <td>{this.props.record.ID}</td>
        <td>
            <a href={this.props.url + "&record_id=" + this.props.record.ID}><strong>{this.props.record.send_title}</strong></a>
            {reject ? <div>{reject}</div> : ''}
            {nomail ? <div>{nomail}</div> : ''}
        </td>
        <td>{this.props.record.resource_count}</td>
        <td>{this.props.record.send_count}</td>
        <td>{this.props.record.fail_count}</td>
        <td>{this.props.record.reject_count}</td>
        <td>{this.props.record.send_type === 'my' ? '본인확인' : (this.props.record.send_type === 'co' ? '공저홍보' : '관심연구자')}</td>
        <td>{this.props.record.worker_id ? this.props.record.worker_name : ''}</td>
        <td>{this.props.record.send_date}</td>
      </tr>
    )
  }
}

export default Mlitem;